import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { AllocationDetailsWithLinks } from 'src/apis/reshuffle-service/types';
import type { ReshuffleServiceRootRequest } from 'src/apis/reshuffle-service/use-reshuffle-service';
import { useAxios } from 'src/hooks/use-axios';
import { Forbidden } from 'src/utils/errors';

type ExecuteProps = { url: string };

type HookConfig = {
  reshuffleServiceRoot: ReshuffleServiceRootRequest;
  allocationId?: string;
};
export function useAllocation({
  reshuffleServiceRoot,
  allocationId,
}: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url }: ExecuteProps) =>
      axios.request<AllocationDetailsWithLinks>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!reshuffleServiceRoot.response) return;

    if (!reshuffleServiceRoot.response.data._links?.getAllocation)
      throw new Forbidden();

    if (!allocationId) return;

    const url = urlTemplate
      .parse(reshuffleServiceRoot.response.data._links.getAllocation.href)
      .expand({ allocationId });

    request.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [reshuffleServiceRoot.response, allocationId]);

  return request;
}

export type AllocationDetailsRequest = ReturnType<typeof useAllocation>;
